import React, { useEffect } from 'react';
import { globalSettings, isUndNullEmp, languageObjGet, LoadingSection, styles } from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'BuildingHeader';

export default function BuildingHeader({
    buildingsId = '',
    building = buildingModelGet({}),
    buildings = [buildingModelGet({})],
    btnSyncDisabled = false,
    methodGetAsync = () => { },
    processType = 0,
    headerSectionValues = {
        levelOne: {
            colOne: {
                className: '',
                label: '',
                value: '',
                icon: '',
            },
            colTwo: {
                className: '',
                label: '',
                value: '',
                icon: '',
            },
            colThree: {
                className: '',
                label: '',
                value: '',
                icon: '',
            },
        },
        levelTwo: {
            colOne: {
                className: '',
                label: '',
                value: '',
                icon: '',
            },
            colTwo: {
                className: '',
                label: '',
                value: '',
                icon: '',
            },
            colThree: {
                className: '',
                label: '',
                value: '',
                icon: '',
            },
        },
    },
    showLoading = false,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    useEffect(() => {
        //console?.log(headerSectionValues);
    }, [headerSectionValues]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card card-outline card-primary shadow-lg'>
                    <LoadingSection alt='loadingSection'
                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                        showText={true}
                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                        height={25}
                        hidden={!showLoading}
                        width={25}
                        languageId={languageObj?.id}
                        subMethod={currentMethod} />

                    {/*header*/}
                    <div className='card-header'>
                        <h6 className='card-title'>
                            <img alt={globalSettings?.labels?.buildings?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.buildingsLogo}></img> - {globalSettings?.labels?.building?.[languageObj?.id]}
                        </h6>
                        <div className='card-tools'>
                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                <i className={globalSettings?.icons?.minus}></i>
                            </button>
                        </div>
                    </div>
                    {/*header*/}

                    {/*body*/}
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div className='form-group'>
                                    {processType === 0 ?
                                        <div className='input-group mb-3'>
                                            <select defaultValue=''
                                                className='form-select'
                                                id={buildingsId}
                                                onChange={(e) => methodGetAsync({ e: e, processType_: 's', subMethod: `${currentMethod} - select`, })}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.buildings?.[languageObj?.id]}>
                                                <option key='nothing' value=''>{globalSettings?.labels?.selectBuilding?.[languageObj?.id]}</option>
                                                {buildings?.map((building, index,) => <option key={index} value={building?.id}>{building?.description}</option>)}
                                            </select>
                                            <div className='input-group-append'>
                                                <button className='btn btn-outline-info'
                                                    disabled={btnSyncDisabled}
                                                    onClick={(e) => methodGetAsync({ e: e, processType_: 'b', subMethod: `${currentMethod} - btn`, })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.search?.[languageObj?.id]}>
                                                    <span className={globalSettings?.icons?.sync} />
                                                </button>
                                            </div>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.building} />
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className='input-group mb-3'>
                                            <input className='form-control bg-transparent'
                                                placeholder={globalSettings?.labels?.building?.[languageObj?.id]}
                                                readOnly
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.building?.[languageObj?.id]}
                                                value={building?.description || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.building} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input className='form-control bg-transparent text-black'
                                            placeholder={globalSettings?.labels?.email?.[languageObj?.id]}
                                            readOnly
                                            //onFocus={() => setBuildingEmailError('')}
                                            tooltip='tooltip'
                                            title={globalSettings?.labels?.email?.[languageObj?.id]}
                                            //value={buildingEmail} />
                                            value={building?.email || ''} />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.envelope} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                </div>
                            </div>

                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input className='form-control bg-transparent text-black'
                                            placeholder={globalSettings?.labels?.contract?.[languageObj?.id]}
                                            //onFocus={() => setBuildingContractError('')}
                                            readOnly
                                            tooltip='tooltip'
                                            title={globalSettings?.labels?.contract?.[languageObj?.id]}
                                            //value={buildingContract} />
                                            value={building?.contractId || ''} />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.fileInvoice} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                </div>
                            </div>
                        </div>

                        {/* #region rowOne */}
                        {!isUndNullEmp({ data: headerSectionValues?.levelOne?.colOne?.value, subMethod: currentMethod })?.result ||
                            !isUndNullEmp({ data: headerSectionValues?.levelOne?.colTwo?.value, subMethod: currentMethod })?.result ||
                            !isUndNullEmp({ data: headerSectionValues?.levelOne?.colThree?.value, subMethod: currentMethod })?.result ?
                            <div className='row'>
                                <div className='col-md-4'>
                                    {!isUndNullEmp({ data: headerSectionValues?.levelOne?.colOne, subMethod: currentMethod, })?.result ?
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input className={!isUndNullEmp({ data: headerSectionValues?.levelOne?.colOne?.className, subMethod: currentMethod, })?.result ?
                                                    headerSectionValues?.levelOne?.colOne?.className : 'form-control bg-transparent text-black'}
                                                    placeholder={headerSectionValues?.levelOne?.colOne?.label}
                                                    readOnly
                                                    tooltip='tooltip'
                                                    title={headerSectionValues?.levelOne?.colOne?.label}
                                                    value={headerSectionValues?.levelOne?.colOne?.value} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={headerSectionValues?.levelOne?.colOne?.icon} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>

                                <div className='col-md-4'>
                                    {!isUndNullEmp({ data: headerSectionValues?.levelOne?.colTwo, subMethod: currentMethod, })?.result ?
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input className={!isUndNullEmp({ data: headerSectionValues?.levelOne?.colTwo?.className, subMethod: currentMethod, })?.result ?
                                                    headerSectionValues?.levelOne?.colTwo?.className : 'form-control bg-transparent text-black'}
                                                    placeholder={headerSectionValues?.levelOne?.colTwo?.label}
                                                    readOnly
                                                    tooltip='tooltip'
                                                    title={headerSectionValues?.levelOne?.colTwo?.label}
                                                    value={headerSectionValues?.levelOne?.colTwo?.value} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={headerSectionValues?.levelOne?.colTwo?.icon} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>

                                <div className='col-md-4'>
                                    {!isUndNullEmp({ data: headerSectionValues?.levelOne?.colThree, subMethod: currentMethod, })?.result ?
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input className={!isUndNullEmp({ data: headerSectionValues?.levelOne?.colThree?.className, subMethod: currentMethod, })?.result ?
                                                    headerSectionValues?.levelOne?.colThree?.className : 'form-control bg-transparent text-black'}
                                                    placeholder={headerSectionValues?.levelOne?.colThree?.label}
                                                    readOnly
                                                    tooltip='tooltip'
                                                    title={headerSectionValues?.levelOne?.colThree?.label}
                                                    value={headerSectionValues?.levelOne?.colThree?.value} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={headerSectionValues?.levelOne?.colThree?.icon} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            </div>
                            :
                            <></>
                        }
                        {/* #endregion rowOne */}

                        {/* #region rowTwo */}
                        {!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colOne?.value, subMethod: currentMethod })?.result ||
                            !isUndNullEmp({ data: headerSectionValues?.levelTwo?.colTwo?.value, subMethod: currentMethod })?.result ||
                            !isUndNullEmp({ data: headerSectionValues?.levelTwo?.colThree?.value, subMethod: currentMethod })?.result ?
                            <div className='row'>
                                <div className='col-md-4'>
                                    {!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colOne, subMethod: currentMethod, })?.result ?
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input className={!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colOne?.className, subMethod: currentMethod, })?.result ?
                                                    headerSectionValues?.levelTwo?.colOne?.className : 'form-control bg-transparent text-black'}
                                                    placeholder={headerSectionValues?.levelTwo?.colOne?.label}
                                                    readOnly
                                                    tooltip='tooltip'
                                                    title={headerSectionValues?.levelTwo?.colOne?.label}
                                                    value={headerSectionValues?.levelTwo?.colOne?.value} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={headerSectionValues?.levelTwo?.colOne?.icon} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>

                                <div className='col-md-4'>
                                    {!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colTwo, subMethod: currentMethod, })?.result ?
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input className={!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colTwo?.className, subMethod: currentMethod, })?.result ?
                                                    headerSectionValues?.levelTwo?.colTwo?.className : 'form-control bg-transparent text-black'}
                                                    placeholder={headerSectionValues?.levelTwo?.colTwo?.label}
                                                    readOnly
                                                    tooltip='tooltip'
                                                    title={headerSectionValues?.levelTwo?.colTwo?.label}
                                                    value={headerSectionValues?.levelTwo?.colTwo?.value} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={headerSectionValues?.levelTwo?.colTwo?.icon} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>

                                <div className='col-md-4'>
                                    {!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colThree, subMethod: currentMethod, })?.result ?
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input className={!isUndNullEmp({ data: headerSectionValues?.levelTwo?.colThree?.className, subMethod: currentMethod, })?.result ?
                                                    headerSectionValues?.levelTwo?.colThree?.className : 'form-control bg-transparent text-black'}
                                                    placeholder={headerSectionValues?.levelTwo?.colThree?.label}
                                                    readOnly
                                                    tooltip='tooltip'
                                                    title={headerSectionValues?.levelTwo?.colThree?.label}
                                                    value={headerSectionValues?.levelTwo?.colThree?.value} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={headerSectionValues?.levelTwo?.colThree?.icon} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingEmailError)}</div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            </div>
                            :
                            <></>
                        }
                        {/* #endregion rowTwo */}

                    </div>
                    {/*body*/}

                    {/*footer*/}
                    {/* <div className='card-footer'></div> */}
                    {/*footer*/}
                </div>
            </div>
        </div >
    )
}